import classnames from 'classnames'
import PropTypes from 'prop-types'
import {Map} from 'immutable'
import {useState} from 'react'

import AddLifeStoryChooser from '../life_story/AddLifeStoryChooser'
import ModuleBox from '../../../../../shared_components/component_templates/ModuleBox'

import {
  useOrganizationCobranding
} from '../../../../../shared_components/OrganizationCobrandingContext'

import {hasOrganizationCobranding} from '../../../../../lib/cobrandingTools'
import {accountEntrySelectPath, newItemPath} from '../../../../../lib/urlTools'
import {eligibleForAccountsImport} from '../../../../../lib/accountPopulationTools'
import {ETHICAL_WILL_ITEM_SLUG} from '../life_story/lifeStoryTools'
import {isCompoundItemResponse, firstTopKitParentElementId} from '../../../../../lib/plan_data/itemResponsesHelper'
import Logger from '../../../../../lib/NewLogger'
import routerUtils from '../../../../../lib/routerUtils'

import PlusIcon from '../../../../../shared_components/core/svg_icons/icons/PlusIcon'

import './itemWithoutResponsesBox.scss'

const ItemWithoutResponsesBox = props => {
  // Adding space between any forward-slashes to allow the item header to wrap and not break the layout --KTW
  const header = props.itemResponse.get('header').replace('/', ' / ')

  const organizationCobranding = useOrganizationCobranding()
  const [showLifeStoryChooser, setShowLifeStoryChooser] = useState(false)

  const addResponseGroup = () => {
    const itemName = props.itemResponse.get('name')
    Logger.log({
      name: 'clicked_add_new',
      payload: {
        context: props.context,
        type: 'vault',
        item: itemName,
        wildcard: itemName,
        compound_item: isCompoundItemResponse(props.itemResponse)
      }
    })

    routerUtils.push(
      newItemPath({
        elementId: firstTopKitParentElementId(props.itemResponse),
        itemSlug: props.itemResponse.get('slug'),
        slug: props.categorySlug,
        path: props.pathname
      })
    )
  }

  const onClickAdd = () => {
    // The Ethical Will item offers a choice first — the guided Life Story
    // experience or the classic freeform/upload form — but only when the firm
    // has My Story access (funeral homes plus whitelisted firms, TK-3197);
    // everyone else goes straight to the classic form.
    if (props.itemResponse.get('slug') === ETHICAL_WILL_ITEM_SLUG && props.hasMyStoryAccess)
      setShowLifeStoryChooser(true)
    else if (eligibleForAccountsImport({item: props.itemResponse, userConfig: props.userConfig}))
      routerUtils.push(accountEntrySelectPath({itemSlug: props.itemResponse.get('slug'), path: props.pathname}))
    else
      addResponseGroup()
  }

  return (
    <>
      <ModuleBox
        className={classnames(
          'item-without-responses-box flex-container',
          {'with-everplans-custom-colors': !hasOrganizationCobranding(
            organizationCobranding
          )}
        )}
        onClick={onClickAdd}>
        <div className='add-response-button'>
          <PlusIcon fill='#FFF' width='10' height='10' />
        </div>
        <div className='heading-and-guidance-text'>
          <h3>{header}</h3>
          {props.itemResponse.get('guidance-text') && <div className='guidance-text'>{props.itemResponse.get('guidance-text')}</div>}
        </div>
      </ModuleBox>
      {
        showLifeStoryChooser &&
          <AddLifeStoryChooser
            addClassic={addResponseGroup}
            exit={() => setShowLifeStoryChooser(false)}
            userConfig={props.userConfig}
          />
      }
    </>
  )
}

ItemWithoutResponsesBox.propTypes = {
  category: PropTypes.instanceOf(Map),
  categorySlug: PropTypes.string,
  context: PropTypes.string,
  hasMyStoryAccess: PropTypes.bool,
  itemResponse: PropTypes.instanceOf(Map).isRequired,
  userConfig: PropTypes.instanceOf(Map).isRequired,
  pathname: PropTypes.string
}

export default ItemWithoutResponsesBox
